import { Component, OnInit } from '@angular/core';
import { UserService } from './../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { department, interaction, division, user, usermaster, performancemaster } from './../../../models/admin';
import { AdminApiService } from './../../../services/admin.service';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import html2pdf from 'html2pdf.js';
import { bmIncomingDashBoard, quater, year } from './../../../models/slakpi';
import { BMApiService } from './../../../services/bm.service';
import { UtilityService } from '../../../services/utility.service';
import { SLAKPIApiService } from '../../../services/slakpi.service';
declare var google: any;
@Component({
  selector: 'app-bench-mark-incoming-dashboard',
  templateUrl: './bench-mark-incoming-dashboard.component.html',
  styleUrls: ['./bench-mark-incoming-dashboard.component.css']
})
export class IncomingOutgoingDashboardComponent implements OnInit {

  public selTab: boolean = true;
  public selTab2: boolean = true;
  public selTab3: boolean = true;
  public selectedDivision: string = '';
  public initialLoading: boolean = false;
  chartOptionchartsummaryIn: any = {};
  chartOptionchartVisitorSatisification: any = {};
  chartOptionchartdashboardChart: any = {};
  chartOptionchartsummaryIndivision: any = {};
  chartOptiondashboardOrganizationChart: any = {};
  columnDefinitions: Column[];
  columnDefinitions1: Column[];
  columnDefinitions2: Column[];
  columnDefinitions3: Column[];
  gridOptions: GridOption;
  gridOptions1: GridOption;
  gridOptions2: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  angularGrid1: AngularGridInstance;
  angularGrid2: AngularGridInstance;
  reportPrecentageCount: any;
  kpiDashboard_data_chart_report: any;
  dataset: any;
  public isAdmin: boolean = false;
  user: any = {};
  login_UserID: string; // number
  public user_data: any;
  public filterSettings: Object;
  objBMIncomingDashboardList: any = [];
  public division_data: any;
  public benchMarkYear_data: any;
  public divisionUnofilter?: number = 0;
  public yearfilter?: number = 0;
  public quarterfilter?: number = 0;
  public quarterData: any;
  public yearData: any;
  public isBMChambion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  isPDFExport: boolean = false;
  noDataImg: any;
  tenantUno: any;
  upcomingVisitDataSet: any;
  consideration_data: any;
  receivedBMReq: any;
  conductedBMReq: any;
  fullfilledBMReq: any;
  scheduledBMReq: any;
  inprogressMeeting: any;
  pendingReq: any;
  local: any;
  reginal: any;
  international: any;
  InprogressDataSet: any = [];
  PendingDataSet: any = [];
  isloadInprogress: boolean = false;
  isloadPending: boolean = false;
  useryearData: any;
  selectedTab: string = "List of Scheduled meetings";
    isLoadScheduled: boolean=true;
  strCurrentYear: any = (new Date()).getFullYear();
  quarterLabel: any;
  constructor(private router: Router, private userService: UserService, public utilityService: UtilityService, public restApi: AdminApiService, public restSLAKPIApi: SLAKPIApiService, public restBMApi: BMApiService, private spinner: SpinnerVisibilityService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.useryearData = this.user.currentYear;
    this.ValidateUserAccess();
    this.initialLoading = true;
  }

  //Method used To Validate User Permission
  ValidateUserAccess() {

    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;
    // this.CheckUserPermission();
    if (this.user.role == 'BM Champions')
      this.isBMChambion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    //if (!this.isAdmin && !this.isBMChambion && !this.isBMTeam && !this.isBMVisitor && !this.isBMAdmin)
    //  this.router.navigateByUrl('/access-denied');
    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Incoming BM dashboard");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }
  }

  ngOnInit() {

    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid1',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.gridOptions1 = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid2',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.gridOptions2 = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid3',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin) {
      this.router.navigateByUrl('/access-denied/');
    }
    if (this.isBMChambion) {
      this.divisionUnofilter = (this.user.divisionUno != '') ? parseInt(this.user.divisionUno) : 0;
    }
    //this.getBenchMarkYear();
    this.loadYear()
    this.getDivisions();
    this.loadQuater();
    this.getBMIncomingDashboardList();



  }
  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    
    this.restBMApi.getQuaterMaster(inpValue)
      .subscribe(data => {
        
        this.quarterData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  getBMIncomingDashboardList() {
    
    this.loading = true;
    this.columnDefinitions1 = [];
    let inpValue = new bmIncomingDashBoard();
    inpValue.organization = '';
    inpValue.division = this.divisionUnofilter ? this.divisionUnofilter : 0;
    inpValue.year = this.yearfilter ? this.yearfilter : 0;

    //inpValue.year = this.yearfilter ? this.yearfilter : 2041;
    
    if (this.initialLoading) {
      inpValue.defaultyear = this.user.currentYear;
    }
    else {
      this.useryearData = ""
      inpValue.defaultyear = this.yearfilter
    }
    if (!inpValue.year) {
      
      inpValue.defaultyear = this.user.currentYear;
      this.useryearData = this.user.currentYear;
    }
    inpValue.defaultyear = inpValue.year;
    //inpValue.quarter = 0;//this.quarterfilter ? this.quarterfilter : 0;
    inpValue.quarter = this.quarterfilter ? this.quarterfilter : 0;
    inpValue.userUno = this.login_UserID;
    this.restBMApi.getBMIncomingDashboard(inpValue)
      .subscribe((data:any) => {
        
        this.initialLoading = false;

        if (data != undefined && data != null && data.length > 0) {
          this.objBMIncomingDashboardList = data[0];
          this.receivedBMReq = this.objBMIncomingDashboardList.receivedReq[0].receivedReq;
          this.conductedBMReq = this.objBMIncomingDashboardList.conductedReq[0].conductedReq;
          this.fullfilledBMReq = this.objBMIncomingDashboardList.fulFilledReq[0].fulFilledReq
          this.scheduledBMReq = this.objBMIncomingDashboardList.scheduledMeeting[0].scheduledMeeting;
          this.inprogressMeeting = this.objBMIncomingDashboardList.inProgressMeeting[0].inProgressMeeting;
          this.pendingReq = this.objBMIncomingDashboardList.pendingMeeting[0].pendingMeeting;
          this.local = this.objBMIncomingDashboardList.local[0].local;
          this.reginal = this.objBMIncomingDashboardList.regional[0].regional;
          this.international = this.objBMIncomingDashboardList.international[0].international;

         
          var filteredDataScheduled = this.objBMIncomingDashboardList.upcomingVisits.filter(a =>
            a.visitRemoteMeetingStatus && a.visitRemoteMeetingStatus.toLowerCase().includes('Scheduled'.toLowerCase()))
          var filteredDataPending = this.objBMIncomingDashboardList.upcomingVisits.filter(a =>
            a.visitRemoteMeetingStatus && a.visitRemoteMeetingStatus.toLowerCase().includes('NO Response'.toLowerCase()))
          var filteredDataInprogress = this.objBMIncomingDashboardList.upcomingVisits.filter(a =>
            a.visitRemoteMeetingStatus && a.visitRemoteMeetingStatus.toLowerCase().includes('In Progress'.toLowerCase()))

          const mockDataset = [];
          for (let i = 0; i < filteredDataScheduled.length; i++) {

            mockDataset[i] = {
              id: i + 1,
              requestFrom: filteredDataScheduled[i].requestFrom,
              requestedTopics: filteredDataScheduled[i].requestedTopics,
              organizationType: filteredDataScheduled[i].organizationType,
              division: filteredDataScheduled[i].concernedDivisionorTeam,
              status: filteredDataScheduled[i].visitRemoteMeetingStatus
            };

          }
          this.upcomingVisitDataSet = mockDataset;
          if (mockDataset.length > 0) {
            this.setUpcomingVisitColnDefn();
          }

          const mockDataset2 = [];
          for (let i = 0; i < filteredDataPending.length; i++) {

            mockDataset2[i] = {
              id: i + 1,
              requestFrom: filteredDataPending[i].requestFrom,
              requestedTopics: filteredDataPending[i].requestedTopics,
              organizationType: filteredDataPending[i].organizationType,
              division: filteredDataPending[i].concernedDivisionorTeam,
              status: filteredDataPending[i].visitRemoteMeetingStatus
            };

          }
          this.PendingDataSet = mockDataset2;
          if (mockDataset2.length > 0) {
            this.setUpcomingVisitColnDefn3();
          }
          const mockDataset1 = [];
          for (let i = 0; i < filteredDataInprogress.length; i++) {

            mockDataset1[i] = {
              id: i + 1,
              requestFrom: filteredDataInprogress[i].requestFrom,
              requestedTopics: filteredDataInprogress[i].requestedTopics,
              organizationType: filteredDataInprogress[i].organizationType,
              division: filteredDataInprogress[i].concernedDivisionorTeam,
              status: filteredDataInprogress[i].visitRemoteMeetingStatus
            };

          }
          this.InprogressDataSet = mockDataset1;
          if (mockDataset1.length > 0) {
            this.setUpcomingVisitColnDefn2();
          }


          
          //if (this.objBMIncomingDashboardList.happinessRating.length > 0) {
          //  this.spinner.show();
          //  setTimeout(() => {
          //    this.dashboardChart(this.objBMIncomingDashboardList.happinessRating);
          //    this.spinner.hide();
          //  }, 200);
          //}

          // No Of meeting
          if (this.objBMIncomingDashboardList.summaryofMeetingStatus.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              
              this.dashboardChart(this.objBMIncomingDashboardList.summaryofMeetingStatus);
              this.spinner.hide();
            }, 400);
          }

          if (this.objBMIncomingDashboardList.summaryofIncomingVisits.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.summaryIncommingChart(this.objBMIncomingDashboardList.summaryofIncomingVisits);


              this.spinner.hide();
            }, 100);
          }

          if (this.objBMIncomingDashboardList.visitorSatification.length > 0) {
            this.spinner.show();
            setTimeout(() => {

              this.visitorSatisfactionChart(this.objBMIncomingDashboardList.visitorSatification);


              this.spinner.hide();
            }, 100);
          }

          if (this.objBMIncomingDashboardList.visitorPerDivision.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.visitperDivisionChart(this.objBMIncomingDashboardList.visitorPerDivision);
              this.spinner.hide();
            }, 100);
          }

          if (this.objBMIncomingDashboardList.summaryofOrganizationType.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.dashboardOrganizationChart(this.objBMIncomingDashboardList.summaryofOrganizationType);
              this.spinner.hide();
            }, 200);
          }

          //if (this.objBMIncomingDashboardList.summaryofIncomingVisits.length > 0) {
          //  this.spinner.show();
          //  setTimeout(() => {
          //    google.charts.load('current', { 'packages': ['table'] });
          //    google.charts.setOnLoadCallback(this.upcommingVisitChart(this.objBMIncomingDashboardList.summaryofIncomingVisits));


          //    this.spinner.hide();
          //  }, 900);
          //}

        }
        setTimeout(() => {
          this.spinner.hide();
          this.loading = false;
        }, 1500);
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.loading = false;
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });


  }
  onChangeTab1(data) {
    if (data == 'In Progress') {
      
      this.isloadPending = false;
      this.isLoadScheduled = false;
      this.isloadInprogress = true;
      this.columnDefinitions2 = [];
      this.setUpcomingVisitColnDefn2();
      this.selectedTab = "List of In-Progress meetings";
    }
    else if (data == 'Pending') {
      this.isLoadScheduled = false;
      this.isloadPending = true;
      this.isloadInprogress = false;
      this.columnDefinitions3 = [];
      this.setUpcomingVisitColnDefn3();
     

      this.selectedTab = "List of Pending meetings";
    }
    else {
      this.isLoadScheduled = true;
      this.isloadPending = false;
      this.isloadInprogress = false;
      this.columnDefinitions1 = [];
      this.setUpcomingVisitColnDefn();
      this.selectedTab = "List of Scheduled meetings";
    }
    // this.getBMIncomingDashboardList();

  }
  onChangeTab(data) {
    var filteredData;
    this.columnDefinitions1 = [];
    this.upcomingVisitDataSet = [];
    filteredData = this.objBMIncomingDashboardList.upcomingVisits.filter(a =>
      a.visitRemoteMeetingStatus && a.visitRemoteMeetingStatus.toLowerCase().includes(data.toLowerCase()))
    const mockDataset = [];
    for (let i = 0; i < filteredData.length; i++) {

      mockDataset[i] = {
        id: i + 1,
        requestFrom: filteredData[i].requestFrom,
        requestedTopics: filteredData[i].requestedTopics,
        organizationType: filteredData[i].organizationType,
        division: filteredData[i].concernedDivisionorTeam
      };

    }

    this.upcomingVisitDataSet = mockDataset;
    if (mockDataset.length > 0) {
      this.loading = false;
      //this.columnDefinitions1 = [];
      this.setUpcomingVisitColnDefn2();
    }
  }

  dashboardChart = (option_data: any) => {
    
    let tempArray = [];
    

    
    let uniqueYear = this.uniqueArray(option_data, 'year', 'year');
    let tempArrayAsc = uniqueYear.sort((a, b) => b.value - a.value);
    let lst4Year = tempArrayAsc;
    //let lst4Year = tempArrayAsc.slice(0, 4);
    lst4Year = lst4Year.sort((a, b) => a.value - b.value);

    //let tempArrayAsc = uniqueYear.sort((a, b) => a.value - b.value);
    //uniqueYear = uniqueYear.sort((a, b) => a.value - b.value);

    //let tempArray_Year = ["2020","2021"];
    //let temparrConducted = [5,10];
    //let temparrOnHold = [20, 30];
    //let temparrOnGoing = [22];
    //let temparrNoResponse = [34];

    let tempArray_Year = [];
    let temparrConducted = [];
    let temparrOnHold = [];
    let temparrOnGoing = [];
    let temparrNoResponse = [];

    for (var i = 0; i < lst4Year.length; i++) {
      tempArray_Year.push(lst4Year[i].value);
      
      let filterData = option_data.filter(x => x.year == lst4Year[i].value);
       //Conducted
      let filterConductedData = filterData.filter(x => x.statusName.toLowerCase() == "Conducted".toLowerCase());
      if (filterConductedData.length > 0) {
        temparrConducted.push(filterConductedData[0].noofMeeting);
      }
      else {
        temparrConducted.push(0);
      }

      //On Hold
      let filterOnHoldData = filterData.filter(x => x.statusName.toLowerCase() == "On Hold".toLowerCase());
      if (filterOnHoldData.length > 0) {
        temparrOnHold.push(filterOnHoldData[0].noofMeeting);
      }
      else {
        temparrOnHold.push(0);
      }

      //In Progress
      let filterInProgressData = filterData.filter(x => x.statusName.toLowerCase() == "In Progress".toLowerCase());
      if (filterInProgressData.length > 0) {
        temparrOnGoing.push(filterInProgressData[0].noofMeeting);
      }
      else {
        temparrOnGoing.push(0);
      }

      //NO Response
      let filterNOResponseData = filterData.filter(x => x.statusName.toLowerCase() == "NO Response".toLowerCase());
      if (filterNOResponseData.length > 0) {
        temparrNoResponse.push(filterNOResponseData[0].noofMeeting);
      }
      else {
        temparrNoResponse.push(0);
      }

      }
            
     


    //tempArray.push(
    //  { name: 'Conducted', type: 'bar', data: temparrConducted },
    //  { name: 'On Hold', type: 'bar', data: temparrOnHold },
    //  { name: 'In Progress', type: 'bar', data: temparrOnGoing },
    //  { name: 'No Response', type: 'bar', data: temparrNoResponse }
    //);

    tempArray.push(
      { name: 'Conducted', type: 'bar', data: temparrConducted, label: { show: true, position: 'top' } },
      { name: 'On Hold', type: 'bar', data: temparrOnHold, label: { show: true, position: 'top' } },
      { name: 'In Progress', type: 'bar', data: temparrOnGoing, label: { show: true, position: 'top' } },
      { name: 'No Response', type: 'bar', data: temparrNoResponse, label: { show: true, position: 'top' } }
    );

    

    //echarts starts
    this.chartOptionchartdashboardChart = {
      title: {
        text: '',
        subtext: ''
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      label: true,
      legend: {
        data: ['Total Approved Request by Received', 'Fulfilled Visit'],
        bottom: '0',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      grid: {
        left: '5%',
        top: '10%',
        right: '0',
        bottom: '10%',
        containLabel: true
      },
      barWidth: "20%",
      yAxis: {
        name: 'No of count',
        nameLocation: 'middle',
        nameGap: 35,
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      xAxis: {
        name: 'Year',
        nameLocation: 'middle',
        nameGap: 40,
        type: 'category',
        data: tempArray_Year
      },
      series: tempArray

       
    };
    // echarts ends
  }

  //dashboardChart = (option_data: any) => {
  //  
  //  let tempArray = [];
  //  let tempArray_Organization = [];
  //  let tempArray_Happiness = [];
  //  for (var i = 0; i < option_data.length; i++) {
  //    if (parseInt(option_data[i].happinessRate) > 0) {
  //      tempArray_Happiness.push(parseInt(option_data[i].happinessRate));

  //      tempArray_Organization.push(option_data[i].organization)
  //    }
  //  }
  //  tempArray.push({ name: "", type: 'bar', data: tempArray_Happiness });

  //  //echarts starts
  //  this.chartOptionchartdashboardChart = {
  //    tooltip: {
  //      trigger: 'axis',
  //      axisPointer: {
  //        type: 'cross',
  //        crossStyle: {
  //          color: '#999'
  //        }
  //      }
  //    },
  //    color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
  //    grid: {
  //      left: '0',
  //      top: '10%',
  //      right: '0',
  //      bottom: '10%',
  //      containLabel: true
  //    },
  //    barWidth: "20%",
  //    toolbox: {
  //      feature: {

  //        //magicType: { show: true, type: ['line', 'bar'] },
  //        //restore: { show: true },
  //        //saveAsImage: { show: true }
  //      }
  //    },
  //    legend: {
  //      data: ['Happiness Rate'],
  //      bottom: '0',
  //      left: 'center',
  //      //padding: [
  //      //  20,  // up
  //      //  0, // right
  //      //  0,  // down
  //      //  0, // left
  //      //],
  //    },
  //    xAxis: {
  //      type: 'category',
  //      data: tempArray_Organization,
  //      axisLabel: {

  //      }
  //    },
  //    yAxis: {
  //      type: 'value'
  //    },
  //    series: tempArray

  //  };
  //   // echarts ends


  //  //const chart = new google.visualization.ComboChart(document.getElementById('dashboardChart'));
  //  //chart.draw(data, options);
  //  }

  summaryIncommingChart = (option_data: any) => {
    
    let tempArray = [];
    let tempArray_Year = [];
    let temparrTotalApproved = [];
    let temparrTotalFulfilled = [];
    //tempArray.push(['Quarter', 'Total Approved Received Request', 'Fulfilled Visit', 'Pending Request In-Progress', 'Cancelled Request']);
    // tempArray.push();
    //tempArray.push(['2021/Q1', 39, 30, 15, 18]);

    //for (var i = 0; i < option_data.length; i++) {
    //  tempArray.push([option_data[i].type, option_data[i].receivedQY, parseInt(option_data[i].totalApproved)]);
    //}
    for (var i = 0; i < option_data.length; i++) {
      tempArray_Year.push(option_data[i].quarter);
      temparrTotalApproved.push(option_data[i].column1);
      temparrTotalFulfilled.push(option_data[i].column2);
    }
    tempArray.push(
      { name: 'Total Approved Request by Received', type: 'bar', data: temparrTotalApproved }, { name: 'Fulfilled Visit', type: 'bar', data: temparrTotalFulfilled });
    

    //echarts starts
    this.chartOptionchartsummaryIn = {
      title: {
        text: '',
        subtext: ''
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['Total Approved Request by Received', 'Fulfilled Visit'],
        bottom: '0',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      grid: {
        left: '0',
        top: '10%',
        right: '0',
        bottom: '10%',
        containLabel: true
      },
      barWidth: "20%",
      yAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      xAxis: {
        type: 'category',
        data: tempArray_Year
      },
      series: tempArray
    };
    // echarts ends

  }

  visitorSatisfactionChart = (option_data: any) => {

    let tempArray = [];
    let tempArray_Year = [];
    let temparrTotalActual = [];
    let temparrTotalTarget = [];
    let uniqueYear = this.uniqueArray(option_data, 'year', 'year');

    let tempuniqueYear = uniqueYear.sort((a, b) => b.value - a.value);


    for (var i = 0; i < option_data.length; i++) {
      tempArray_Year.push(option_data[i].receivedQY);
      let SatificationRate = (option_data[i].satificationRate != "") ? (parseFloat(option_data[i].satificationRate)) : 0.00
      temparrTotalActual.push(parseFloat(SatificationRate.toString()).toFixed(2));
      temparrTotalTarget.push(parseInt(option_data[i].target));

    }


    tempArray.push(
      { name: 'Actual', type: 'bar', data: temparrTotalActual, label: { show: true, position: 'top',fontSize: 11 } },
      { name: 'Target', type: 'bar', data: temparrTotalTarget, label: { show: true, position: 'top', fontSize: 11}}
    );
    

    //echarts starts
    this.chartOptionchartVisitorSatisification = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      grid: {
        left: '5%',
        top: '10%',
        right: '0',
        bottom: '20%',
        containLabel: true
      },
      toolbox: {
        feature: {

          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      barWidth: "20%",
      barGap: 0.4,
      legend: {
        data: ['Actual', 'Target'],
        bottom: '0',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      xAxis: [
        {
          name: 'Year',
          nameLocation: 'middle',
          nameGap: 30,
          type: 'category',
          data: tempArray_Year,
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [{
        name: 'Happiness Percentage',
        nameLocation: 'middle',
        nameGap: 50,
        type: "value",
        //min: 96,
        axisLabel: {
          formatter: "{value}%"
        }
      }],
      series: tempArray
    };
    // echarts ends



    //var chart = new google.visualization.ComboChart(document.getElementById('chart_VisitorSatisification'));
    //chart.draw(data, options);

  }
  visitperDivisionChart = (option_data: any) => {

    // let tempArray = [['Division', 'Visit Count']];
    let tempArray = [];

    for (var i = 0; i < option_data.length; i++) {

      tempArray.push({ name: this.sentenceCase(option_data[i].divisionName), value: parseInt(option_data[i].divisionCount) });
      //  temparrTotalActual.push();
    }
    



    //echarts starts
    this.chartOptionchartsummaryIndivision = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },

      legend: {
        type: 'scroll',
        orient: 'vertical',
        right: -30,
        top: 0,
        bottom: 20,
        pageIconColor: '#087b36',
        pageIconInactiveColor: '#999999'
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],

      series: [
        {
          name: '',
          type: 'pie',
          //radius: ['30%', '80%'],
          center: ["25%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return d.value;
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },

          data: tempArray
        }
      ]
    };
    // echarts ends



    //var chart = new google.visualization.PieChart(document.getElementById('chart_summaryIn_division'));
    //chart.draw(data, options);

  }

  upcommingVisitChart = (option_data: any) => {

    let tempArray = [['Type', 'Quarter', 'Visit Count']];
    for (var i = 0; i < option_data.length; i++) {
      tempArray.push([option_data[i].type, option_data[i].receivedQY, parseInt(option_data[i].totalApproved)]);
    }
    

    //var data = new google.visualization.arrayToDataTable(tempArray);

    var data = new google.visualization.DataTable();
    data.addColumn('string', 'Request From');
    data.addColumn('string', 'Request Topic');
    data.addColumn('string', 'Organisation Type');
    data.addRows([
      ['Dubai Police', 'service level', 'Government'],
      ['Emirates Global Aluminum', 'General Tpoic', 'Private'],
      ['Dubai Government Workshop', 'General Tpoic', 'Government'],
      ['Smart Dubai', 'General Tpoic', 'Government']
    ]);

    var table = new google.visualization.Table(document.getElementById('chart_upcommingVisit'));

    table.draw(data, { showRowNumber: true, width: '100%', height: '100%' });

  }


  dashboardOrganizationChart = (option_data: any) => {
    
    let tempArray = [];
    //for (var i = 0; i < option_data.length; i++) {
    //tempArray.push([option_data[i].organization, parseInt(option_data[i].happinessRate)]);
    //}
    tempArray.push({ name: 'Government', value: option_data[0].noOfGovernment }, { name: 'Private', value: option_data[0].noOfPrivate }, { name: 'Semi Government', value: option_data[0].noOfSemiGovernment });


    //echarts starts
    this.chartOptiondashboardOrganizationChart = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },

      legend: {
        bottom: '0',
        left: 'center',
        //orient: "vertical",

        //padding: [
        //  20,  // up
        //  20, // right
        //  0,  // down
        //  0, // left
        //],
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['30%', '80%'],
          center: ["50%", "40%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return d.value;
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },

          data: tempArray
        }
      ]
    };
    // echarts ends



    //const chart = new google.visualization.PieChart(document.getElementById('dashboardOrganizationChart'));
    //chart.draw(data, options);
  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getBenchMarkYear() {
    
    let date = new Date();
    let pastYear = date.getFullYear() - 1;
    let currentYear = date.getFullYear();
    let futureYear = date.getFullYear() + 1;

    this.benchMarkYear_data = [
      { text: pastYear, value: pastYear },
      { text: currentYear, value: currentYear },
      { text: futureYear, value: futureYear }
    ];
  }

  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restSLAKPIApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  onChangeFilter(e, type: any) {
    
    if (type == 'division') {
      this.selectedDivision = (e && e.length > 0 && e[0].value != null) ? e[0].text : '';
    }
   
   
    let temp = this;
    this.spinner.show();
    setTimeout(function () {
      if (type == 'quarter') {
        if (temp.quarterfilter != null && temp.quarterfilter != undefined) {
          if (e.length > 0) {
            temp.quarterLabel = " - " + e[0].text;
          }
          else {
            temp.quarterLabel = "";
          }
        }
      }
      else {
        temp.quarterLabel = "";
      }
      temp.getBMIncomingDashboardList();
    }, 1000);
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  setUpcomingVisitColnDefn3() {
    let temp = this;
    this.columnDefinitions3 = [
      {
        id: 'requestFrom', name: 'Request From', field: 'requestFrom', sortable: true, width: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.PendingDataSet, 'requestFrom', 'requestFrom'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'requestedTopics', name: 'Requested Topics', field: 'requestedTopics', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.PendingDataSet, 'requestedTopics', 'requestedTopics'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organizationType', name: 'Organization Type', field: 'organizationType', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.PendingDataSet, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'division', name: 'Concerned Divisons', field: 'division', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.PendingDataSet, 'division', 'division'),
          model: Filters.multipleSelect,
        }
      }

    ]


  }

  setUpcomingVisitColnDefn2() {
    let temp = this;
    this.columnDefinitions2 = [
      {
        id: 'requestFrom', name: 'Request From', field: 'requestFrom', sortable: true, width: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.InprogressDataSet, 'requestFrom', 'requestFrom'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'requestedTopics', name: 'Requested Topics', field: 'requestedTopics', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.InprogressDataSet, 'requestedTopics', 'requestedTopics'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organizationType', name: 'Organization Type', field: 'organizationType', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.InprogressDataSet, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'division', name: 'Concerned Divisons', field: 'division', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.InprogressDataSet, 'division', 'division'),
          model: Filters.multipleSelect,
        }
      }

    ]


  }

  setUpcomingVisitColnDefn() {
    let temp = this;
    this.columnDefinitions1 = [
      {
        id: 'requestFrom', name: 'Request From', field: 'requestFrom', sortable: true, width: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.upcomingVisitDataSet, 'requestFrom', 'requestFrom'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'requestedTopics', name: 'Requested Topics', field: 'requestedTopics', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.upcomingVisitDataSet, 'requestedTopics', 'requestedTopics'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organizationType', name: 'Organization Type', field: 'organizationType', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.upcomingVisitDataSet, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'division', name: 'Concerned Divisons', field: 'division', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.upcomingVisitDataSet, 'division', 'division'),
          model: Filters.multipleSelect,
        }
      }

    ]


  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'displayNameEn', name: 'Display Name', field: 'displayNameEn', sortable: true, formatter: this.nameFormatter,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'displayNameEn', 'displayNameEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'emailId', name: 'Email ID', field: 'emailId', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'emailId', 'emailId'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'lastLogin', name: 'Last Login', field: 'lastLogin', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'lastLogin', 'lastLogin'),
          model: Filters.multipleSelect,
        }
      }

    ]


  }

  nameFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return '<div class="e-image"><img class="e-avatar" src="' + dataContext.userPhoto + '" alt="user"></div><span class="name"> ' + dataContext.displayNameEn + '</span>';
  };



  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  angularGridReady1(angularGrid: AngularGridInstance) {
    this.angularGrid1 = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  angularGridReady2(angularGrid: AngularGridInstance) {
    this.angularGrid2 = angularGrid;
    this.userService.angularGrid = angularGrid;
  }



  sentenceCase(str) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();

    return str.replace(/\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() +
          txt.substr(1).toLowerCase();
      });
  }

  getPivotArray(dataArray, rowIndex, colIndex, dataIndex) {
    var result = {}, ret = [];
    var newCols = [];
    for (var i = 0; i < dataArray.length; i++) {

      if (!result[dataArray[i][rowIndex]]) {
        result[dataArray[i][rowIndex]] = {};
      }
      result[dataArray[i][rowIndex]][dataArray[i][colIndex]] = dataArray[i][dataIndex];

      //To get column names
      if (newCols.indexOf(dataArray[i][colIndex]) == -1) {
        newCols.push(dataArray[i][colIndex]);
      }
    }

    //newCols.sort(); --Sort by alphabet
    var item = [];

    //Add Header Row
    item.push('Year');
    item.push.apply(item, newCols);
    ret.push(item);

    //Add content 
    for (var key in result) {
      item = [];
      item.push(key);
      for (var i = 0; i < newCols.length; i++) {
        item.push(result[key][newCols[i]] || 0);
      }
      ret.push(item);
    }
    return ret;
  }


  exportToPDF() {
    //this.loading = true;
    var temp = this;
    this.isPDFExport = true;
    this.spinner.show();
    window.scroll(0, 0);
    let data: any;
    

    
    data = document.getElementById('diviIncomingSection');
    

    let strDate = new Date().getFullYear() + "" + (new Date().getMonth() + 1) + "" + new Date().getDate();


    var opt = {
      margin: 0.5,
      filename: 'BM Incoming Summary_' + strDate + '.pdf',
      //filename: 'Report.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2.4, useCORS: true },
      jsPDF: { unit: 'in', format: 'a2', orientation: 'landscape' } //portrait

    };

    // New Promise-based usage:
    //html2pdf().from(data).set(opt).save();
    //hd.style.display = 'block';
   
    setTimeout(() => {
      //this.loading = false;
      html2pdf().from(data).set(opt).save();
      this.isPDFExport = false;
      temp.spinner.hide();
    }, 300)
  }

}
